import { render } from "./NotificationsContainer.vue?vue&type=template&id=1d65d3bb&scoped=true"
import script from "./NotificationsContainer.vue?vue&type=script&lang=js"
export * from "./NotificationsContainer.vue?vue&type=script&lang=js"

import "./NotificationsContainer.vue?vue&type=style&index=0&id=1d65d3bb&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1d65d3bb"

export default script